const ChangePassword = ({ changeSettingsPage }) => {
  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Change Password</h3>
      <p className="accountSettingsToggleDescription">
        Change the password you use to log in.
      </p>
      <button
        className="accountSettingsButton"
        onClick={() => changeSettingsPage("ChangePassword")}
      >
        Change Password
      </button>
    </div>
  );
};

export default ChangePassword;
